export default __webpack_public_path__ + "static/media/sv_2.70b60e80.webp";